import * as yup from 'yup';
import { validationsMessages } from 'lib';
import { RuleSetIcon } from '../../../../assets';

export const DROOLS_DOCS_LINK =
    'https://docs.drools.org/8.39.0.Final/drools-docs/docs-website/drools/language-reference/index.html';

export interface RuleSetFormValues {
    ruleName: string;
    description?: string;
    whenBase64: string;
    thenBase64: string;
}

export const CreateRuleSetDefaults: RuleSetFormValues = {
    ruleName: '',
    description: '',
    whenBase64: '',
    thenBase64: '',
};

export const CreateRuleSetSchema = yup.object({
    ruleName: yup.string().required(validationsMessages.required),
    description: yup.string(),
    whenBase64: yup.string().required(validationsMessages.required),
    thenBase64: yup.string().required(validationsMessages.required),
});

export const createRuleSetConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'rule-set': {
        imgSrc: RuleSetIcon,
        headingText: 'Single Rule Editor',
        iconStyles: { display: 'none' },
    },
};

export const ruleSetFormStyles = {
    popperStyles: {
        width: '186px',
        height: '40px',
    },
    codeMirrorHeight: '235px',
    droolsDocsContainer: {
        position: 'absolute',
        bottom: '-57px',
        left: '2px',
    },
    droolsDocsButtonStyles: {
        width: '166px',
        height: '40px',
    },
};
